import dynamic from 'next/dynamic';

export const Notifications = dynamic(() => import('./notifications'), { ssr: false });
